<template>
  <div
    :class="[
      'tablet',
      `key${keyName.toLowerCase()}`,
      classes,
      keyStateClass,
      `special-${keySpecial}`
    ]"
    :title="title"
    v-hammer:press="handlePress"
    v-hammer:pressup="handleRelease"
    v-hammer:pan="panstart"
    v-hammer:panstart="panstart"
    v-hammer:panend="handlePan"
    :role="role"
    :tabindex="tabIndex"
  >
    <slot />
  </div>
</template>

<script>
import { convertSymbolToName } from 'utils/key-util';
import BaseKey from 'mixins/BaseKey';
import { mapState } from 'vuex';

export default {
  mixins: [BaseKey],

  data() {
    return {
      isPressed: false
    };
  },

  props: {
    press: {
      type: Function,
      required: true
    },
    release: {
      type: Function,
      required: true
    },
    role: {
      type: undefined | String,
      default: undefined
    },
    tabIndex: {
      type: undefined | Number,
      default: undefined
    }
  },

  computed: {
    ...mapState('keyboard', ['showSpecialKeys']),
    keySpecial() {
      return this.special ? this.special : this.character;
    },
    keyCharacter() {
      return this.showSpecialKeys ? this.keySpecial : this.character;
    },

    keyName() {
      return convertSymbolToName(this.keyCharacter);
    },

    isExpectedKey() {
      return this.keyCharacter === this.expectedKey;
    },

    isToldHoldTypeTarget() {
      return this.isTouchHold && this.isExpectedKey && this.holdKeyPressed;
    },

    isTargetedKey() {
      return !this.isTouchHold && this.isExpectedKey && this.showTargets;
      // return this.showTargets && this.isExpectedKey;
    },

    isHomeRow() {
      return this.roofs;
    },

    classes() {
      const isKey123 = this.character === '123';
      const baseClasses = {
        ...this.baseClasses,
        active: isKey123 ? true : this.baseClasses.active
      };

      if (this.showSpecialKeys) {
        return {
          ...baseClasses,
          active: this.special,
          homeRow: this.isHomeRow,
          oneHandedTyping: !!this.oneHandedTypingHand,
          special: this.showSpecialKeys,
          target: this.isToldHoldTypeTarget || this.isTargetedKey
        };
      }

      let showTargets =
        (this.showTargets && this.isTargetedKey && this.holdKeyPressed) ||
        this.isTargetedKey ||
        this.isToldHoldTypeTarget;

      // showTargets is set to false on purpose, comes undefined if not set
      if (this.showTargets === false) {
        showTargets = false;
      }

      return {
        ...baseClasses,
        homeRow: this.isHomeRow,
        oneHandedTyping: !!this.oneHandedTypingHand,
        special: this.showSpecialKeys,
        target: showTargets
      };
    },

    title() {
      return `${this.keyName.toLowerCase()} key`;
    }
  },

  methods: {
    panstart() {},

    panend() {},

    handlePan() {
      if (this.isPressed) {
        this.handleRelease();
      }
    },

    addKeyClass(key) {
      return `key${key}`;
    },

    modifyWithShift(key) {
      const specialKeys = {
        ';': ':',
        ',': '!',
        '.': '?'
      };

      const isLetter = key.length === 1 && /[a-z]/.test(key);
      return isLetter ? key.toUpperCase() : specialKeys[key];
    },

    handlePress() {
      this.isPressed = true;
      this.press(this.keyCharacter);
    },

    handleRelease() {
      this.isPressed = false;
      this.release(this.keyCharacter);
    }
  }
};
</script>
